module.exports = __webpack_public_path__ + "static/img/buttonExercise.3cce88a6.png";